import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type BlockedPeriod from 'modules/timeoff/store/models/BlockedPeriods/BlockedPeriod'
import type LeaveType from 'modules/timeoff/store/models/LeaveType'

import './index.styles.css'
interface Props {
  blockedPeriod: BlockedPeriod
}

const BlockedPeriodInfo = ({ blockedPeriod }: Props) => {
  const leaveTypes = blockedPeriod.leaveTypes
    ?.map((leave_type: LeaveType) => leave_type.name)
    .join(', ')

  return (
    <Box>
      <Box textAlign="left" paddingTop="s16">
        <li>
          <span className={'BlockedPeriodInfo_calendarBlockedPeriodTooltipDate'}>
            {blockedPeriod.rangeLabel}
          </span>
        </li>
        <li>
          <span className={'BlockedPeriodInfo_blockedPeriodLeaveTypesTooltipDate'}>
            {leaveTypes}
          </span>
        </li>
      </Box>
    </Box>
  )
}

export default observer(BlockedPeriodInfo)
